export const APP_NAME = "99 Problems";
export const SLOGAN = "..but a Deck ain't one";
export const APP_TITLE = "99 Problems - Commander Deck Optimizer";
export const APP_DESCRIPTION = "99 Problems, but building the perfect deck ain't one";
export const SHARE_TEXT = "Check out 99 Problems - the Commander deck builder! 🎴";

export const brandColors = {
  gold: "#d4af37",
  bronze: "#9a6b2f",
  black: "#0a0a0a",
  accent: "#e8b454",
} as const;

/** Native share sheet where available, otherwise a Twitter/X intent in a new tab. */
export async function shareApp(url: string = window.location.origin): Promise<void> {
  if (typeof navigator.share === "function") {
    try {
      await navigator.share({ title: APP_TITLE, text: SHARE_TEXT, url });
      return;
    } catch (error) {
      if (error instanceof DOMException && error.name === "AbortError") return;
    }
  }
  const intent = new URL("https://twitter.com/intent/tweet");
  intent.searchParams.set("text", SHARE_TEXT);
  intent.searchParams.set("url", url);
  window.open(intent.toString(), "_blank", "noopener,noreferrer");
}
